export const FETCH_USER_PROGRAM_ENROLLMENTS_REQUEST = 'FETCH_USER_PROGRAM_ENROLLMENTS_REQUEST';
export const FETCH_USER_PROGRAM_ENROLLMENTS_SUCCESS = 'FETCH_USER_PROGRAM_ENROLLMENTS_SUCCESS';
export const FETCH_USER_PROGRAM_ENROLLMENTS_FAILURE = 'FETCH_USER_PROGRAM_ENROLLMENTS_FAILURE';
